export function ValueCard({ icon: Icon, title, desc }) {
  return (
    <div className="p-5 bg-neutral-900/50 border border-neutral-800 rounded-xl">
      <Icon className="w-6 h-6 text-brand-gold mb-3" />
      <div className="text-white font-medium mb-1">{title}</div>
      <div className="text-xs text-neutral-500">{desc}</div>
    </div>
  );
}

export function PhaseCard({ num, title, desc }) {
  return (
    <div className="p-4 bg-black/30 rounded-lg border border-white/5">
      <div className="text-xs text-brand-gold font-bold mb-2">FASE {num}</div>
      <div className="text-white font-medium mb-1">{title}</div>
      <div className="text-xs text-neutral-400">{desc}</div>
    </div>
  );
}
